import { YStack, XStack, Text, Button, Circle } from "tamagui";
import { MdOutlinePhone } from "react-icons/md";
import { colors } from "@styles/colors";
import { useUser } from "@utils/store/user/useUser";

export const GasStationInfo = () => {
  const { chooseIdentity } = useUser();
  const supplier = chooseIdentity?.primary_supplier;
  const isOpen = supplier?.is_open_now;
  const phone = supplier?.phone;

  return (
    <XStack alignItems="center" justifyContent="space-between">
      <YStack gap={4}>
        <XStack alignItems="center" gap={8}>
          <Text color="white" fontSize={17} fontWeight="700">
            {supplier?.supplier_name}
          </Text>
          <XStack backgroundColor="rgba(255,255,255,0.18)" borderRadius={20} paddingHorizontal={8} paddingVertical={3} alignItems="center" gap={4}>
            <Circle size={6} backgroundColor={isOpen ? colors.green : colors.danger} />
            <Text color="white" fontSize={10} fontWeight="500">
              {isOpen ? "營業中" : "尚未營業"}
            </Text>
          </XStack>
        </XStack>
      </YStack>

      {phone && (
        <Button
          height={34}
          borderRadius={10}
          backgroundColor="rgba(255,255,255,0.18)"
          borderWidth={1}
          borderColor="rgba(255,255,255,0.35)"
          paddingHorizontal={14}
          pressStyle={{ opacity: 0.8 }}
          onPress={() => window.open(`tel:${phone}`)}>
          <XStack alignItems="center" gap={5}>
            <MdOutlinePhone color="white" size={16} />
            <Text color="white" fontSize={13} fontWeight="500">
              撥打
            </Text>
          </XStack>
        </Button>
      )}
    </XStack>
  );
};

export default GasStationInfo;
